// extracted by mini-css-extract-plugin
export default {"wrapper":"accept_wrapper__c8vF9","btn":"accept_btn__Y8rZb"};